var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56964 2.09533H8.62763C8.96359 2.09533 9.23633 1.82258 9.23633 1.48663C9.23633 1.15067 8.96359 0.87793 8.62763 0.87793H4.56964C4.23368 0.87793 3.96094 1.15067 3.96094 1.48663C3.96094 1.82258 4.23368 2.09533 4.56964 2.09533Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13518 4.12365V10.8193C2.13518 11.9397 3.0438 12.8483 4.16418 12.8483H9.03378C10.1542 12.8483 11.0628 11.9397 11.0628 10.8193V4.12365H11.7304C12.0339 4.12365 12.2802 3.85091 12.2802 3.51495C12.2802 3.17899 12.0339 2.90625 11.7304 2.90625H1.46779C1.16425 2.90625 0.917969 3.17899 0.917969 3.51495C0.917969 3.85091 1.16425 4.12365 1.46779 4.12365H2.13537H2.13518ZM4.97578 5.54395V10.4135C4.97578 10.6375 5.15757 10.8193 5.38158 10.8193C5.60559 10.8193 5.78738 10.6375 5.78738 10.4135V5.54395C5.78738 5.31994 5.60559 5.13815 5.38158 5.13815C5.15757 5.13815 4.97578 5.31994 4.97578 5.54395ZM7.41058 5.54395V10.4135C7.41058 10.6375 7.59237 10.8193 7.81638 10.8193C8.04038 10.8193 8.22218 10.6375 8.22218 10.4135V5.54395C8.22218 5.31994 8.04038 5.13815 7.81638 5.13815C7.59237 5.13815 7.41058 5.31994 7.41058 5.54395Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDeleteIcon);
export default __webpack_public_path__ + "static/media/notification-delete-icon.752fe1932bb2f7519a7d815245102cb3.svg";
export { ForwardRef as ReactComponent };